import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, Container, Paper, Stack, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { config } from "../config";

export default function Login() {
  const { user, login, loading } = useAuth();
  const [params] = useSearchParams();
  const returnTo = params.get("returnTo") || "/account";

  // Hosted targets: kick off the OIDC redirect immediately. Embedded targets:
  // explain that NetSuite SSO handles auth.
  useEffect(() => {
    if (loading || user || config.isEmbedded) return;
    if (!config.oidc.authority || !config.oidc.clientId) return;
    login(returnTo);
  }, [loading, user, login, returnTo]);

  if (loading) return null;
  if (user) return <Navigate to={returnTo} replace />;

  if (config.isEmbedded) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Alert severity="info">
          You are signed in via NetSuite. No separate login is needed when this
          site is embedded as a Suitelet.
        </Alert>
      </Container>
    );
  }

  if (!config.oidc.authority || !config.oidc.clientId) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Alert severity="warning">
          OIDC is not configured. Set VITE_OIDC_AUTHORITY and VITE_OIDC_CLIENT_ID.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Stack spacing={3} alignItems="center">
          <Typography variant="h2" sx={{ fontSize: "1.6rem" }}>B2B Sign In</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <CircularProgress size={20} />
            <Typography>Redirecting to NetSuite…</Typography>
          </Box>
          <Button variant="outlined" onClick={() => login(returnTo)}>
            Continue to NetSuite Sign In
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
